<div class="wasm-container">
  <iframe
    *ngIf="iframeSrc"
    id="wasmFrame"
    [src]="iframeSrc"
    sandbox="allow-scripts allow-same-origin allow-downloads">
  </iframe>

  <!-- Loading 覆盖层 -->
  <div class="loading-overlay" *ngIf="loading">
    <div class="progress-box">
      <div class="title">正在加载编辑器</div>

      <div class="progress-bar">
        <div
          class="progress-fill"
          [style.width.%]="progress">
        </div>
      </div>

      <div class="progress-text">
        {{ progress }}% · {{ stageText }}
      </div>
    </div>
  </div>
</div>
